import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    SMALL_BURGERS_CATALOG_CONFIG,
    SMALL_BURGERS_CATALOG_TITLE_KEY,
    SmallBurgersSelectedItems,
} from './InstancesCatalogSmallBurgers-types'

const InstancesCatalogSmallBurgersComponent = () => {
    const [selectedItems, setSelectedItems] = useState<SmallBurgersSelectedItems>([])

    return (
        <Content title={SMALL_BURGERS_CATALOG_TITLE_KEY}>
            <CustomList
                type={SMALL_BURGERS_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={SMALL_BURGERS_CATALOG_CONFIG.additionalData}
            />
        </Content>
    )
}

export const InstancesCatalogSmallBurgers = checkAvailableModule('instancesCatalog/smallBurgers')
    ? InstancesCatalogSmallBurgersComponent
    : null
